import { Controller } from "@hotwired/stimulus"
import Logger from "../lib/logger"

// This controller listens for events and reloads specified Turbo Frames.
// For interval-based polling instead (with visibility pause/resume, ETag/hash
// de-duplication, and caching), see frame_refresh_controller.js.
// Usage:
// <div data-controller="frame-reloader" data-action="address:coordinates-updated@window->frame-reloader#reload">
//   <turbo-frame id="quotemap" data-frame-reloader-target="frame"></turbo-frame>
// </div>
export default class extends Controller {
  static targets = ["frame"]

  reload(event) {
    Logger.debug(`[FrameReloader] Caught event ${event.type}, reloading ${this.frameTargets.length} frames`)
    this.frameTargets.forEach(frame => {
      if (frame.hasAttribute("src")) {
        // Force a reload by resetting the src attribute
        const src = frame.getAttribute("src")
        frame.removeAttribute("src")
        setTimeout(() => {
          frame.setAttribute("src", src)
        }, 10)
      } else {
        frame.reload()
      }
    })
  }
}
